import {
  ModalBody,
  ModalHeader,
  ModalFooter
  // @ts-ignore
} from 'reactstrap'
import styled from 'styled-components'
// @ts-ignore
import { Button } from 'dsm-react-lib'
import { IconX, IconClock, IconDownload, IconLock } from '@tabler/icons-react'
import { StyledModal } from '../../@core/containers/Ali/styles'

const Title = styled.h3`
  color: var(--color-primary);
  font-weight: 600;
  padding-left: 0.5rem;
`
const Content = styled.div`
  font-size: 14px;
  padding-left: 0.5rem;

  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`

export const StyledModalHeader = styled(ModalHeader)`
  justify-content: space-between;
  .custom-close-btn {
    position: absolute !important;
    top: 5px !important; /* Adjust as needed */
    right: 15px; /* Adjust as needed */
    div {
      margin: auto;
    }
    svg {
      stroke: var(--text-body) !important;
    }
    span {
      visibility: hidden !important;
    }
  }
  .btn-close {
    display: none;
  }
`

interface ContributorModalProps {
  isOpen: boolean
  toggle: any
  handleToggleArcRequestModal: () => void
  isContributor: boolean
}

const ContributorModal: React.FC<ContributorModalProps> = ({
  isOpen,
  toggle = true,
  handleToggleArcRequestModal,
  isContributor
}: ContributorModalProps) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfoData')!)
  const requestPending = userInfo?.userMetaData?.isInvDesktopContributorArcRequestRaised

  return (
    <>
      <StyledModal isOpen={isOpen} toggle={toggle} centered size="lg">
        <StyledModalHeader
          toggle={toggle}
          data-testid="closeBtn"
          close={
            <IconX size={24} color="var(--text-body)" onClick={toggle} className="cursor-pointer" />
          }>
          {isContributor ? "You're a contributor on Centrali" : 'Become a Contributor on Centrali'}
        </StyledModalHeader>
        <ModalBody className="flex-grow-1 bg-surface">
          <Title> What is a contributor? </Title>
          <Content>
            If you&apos;re an application owner, the Centrali Contributor role could be your next
            step to unlocking new stages of product growth. Start onboarding your applications onto
            the portal. From this, colleagues can discover, request ARC roles and access your
            application all from the portal. Utilise Centrali&apos;s notification service to send
            and schedule in-portal notifications and emails to your user base. You&apos;re not in
            this alone - share management of your application and its notifications with other
            contributors.
          </Content>
          <Title> Is the role right for me? </Title>
          <Content>
            <ul>
              <li>
                Have you developed dashboards, app services or perhaps an app with Centrali OS?
              </li>
              <li>
                Is there an existing application whose app details page, URL or ARC roles you&apos;d
                like to manage?
              </li>
              <li>
                Are you an app owner or developer who wishes to send updates & announcements to
                their user base?
              </li>
            </ul>
            If you answered yes to any of the questions, no matter how big or small your
            application, download a copy of our Contributor guide - this role could have your name
            on it.
          </Content>
          <Title>What&apos;s in it for me? </Title>
          <Content>
            <ul>
              <li>
                First impressions count: as a contributor you will have greater control over the
                presentation and access of your applications on Centrali.
              </li>
              <li>
                Building the bridge between developers & users: with our notification service,
                seamlessly communicate to users to announce features, key updates & planned
                downtime.
              </li>
              <li>
                Put your app on a pedestal: improve product exposure, show off your hard work, and
                allow new users to discover value from your application.
              </li>
            </ul>
          </Content>
          <Title> Before you jump in... </Title>
          <Content>
            If you&apos;d like to learn more: read our contributor guide. If you have any further
            questions, we&apos;re just a click away - send us a message via Need Help.
          </Content>
        </ModalBody>
        <hr />
        <ModalFooter>
          <a
            href="https://savingsandinvestments.sharepoint.com/sites/MGAnalytics551/SiteAssets/Centrali/Contributor%20guide.pdf"
            target="_blank"
            rel="noopener noreferrer">
            <Button
              label="Download Contributor guide"
              color="info"
              icon={<IconDownload size={20} />}
              data-testid="downloadContributorGuide"
            />
          </a>
          {!isContributor && (
            <Button
              label={requestPending ? 'Pending access' : 'Request access'}
              color="warning"
              icon={requestPending ? <IconClock size={20} /> : <IconLock size={20} />}
              onClick={handleToggleArcRequestModal}
              disabled={requestPending}
              data-testid="requestContributorAccess"
            />
          )}
        </ModalFooter>
      </StyledModal>
    </>
  )
}

export default ContributorModal
